// @flow

import _ from 'lodash';
import { formatNumberInThousand } from 'src/helpers';
import type { AnalyticsState, AnalyticsAction } from 'stores/flow-type/analytics-v2.type';

import {
  GET_TOP_SEARCH_TERMS_REQUEST,
  GET_TOP_SEARCH_TERMS_SUCCESS,
  GET_TOP_SEARCH_TERMS_FAILURE,
  GET_TOP_SEARCH_TERM_DETAIL_REQUEST,
  GET_TOP_SEARCH_TERM_DETAIL_SUCCESS,
  GET_TOP_SEARCH_TERM_DETAIL_FAILURE,
  GET_TOTAL_SEARCH_REVENUE_REQUEST,
  GET_TOTAL_SEARCH_REVENUE_SUCCESS,
  GET_TOTAL_SEARCH_REVENUE_FAILURE,
  GET_TOP_SEARCH_PRODUCT_PERFORMANCE_REQUEST,
  GET_TOP_SEARCH_PRODUCT_PERFORMANCE_SUCCESS,
  GET_TOP_SEARCH_PRODUCT_PERFORMANCE_FAILURE,
  GET_SEARCH_TERMS_WITHOUT_RESULT,
  GET_SEARCH_TERMS_WITHOUT_RESULT_SUCCESS,
  GET_SEARCH_TERMS_WITHOUT_RESULT_FAILURE,
  GET_SEARCHES_WITHOUT_RESULT_RATE,
  GET_SEARCHES_WITHOUT_RESULT_RATE_SUCCESS,
  GET_SEARCHES_WITHOUT_RESULT_RATE_FAILURE,
  GET_SEARCHES_CLICK_RATE,
  GET_SEARCHES_CLICK_RATE_SUCCESS,
  GET_SEARCHES_CLICK_RATE_FAILURE,
  GET_SEARCHES_WITHOUT_CLICK_RATE,
  GET_SEARCHES_WITHOUT_CLICK_RATE_SUCCESS,
  GET_SEARCHES_WITHOUT_CLICK_RATE_FAILURE,
  GET_CONVERSION_RATE,
  GET_CONVERSION_RATE_SUCCESS,
  GET_CONVERSION_RATE_FAILURE,
  GET_SEARCHES_RATE,
  GET_SEARCHES_RATE_SUCCESS,
  GET_SEARCHES_RATE_FAILURE,
  EXPORT_DATA_REQUEST,
  EXPORT_DATA_SUCCESS,
  EXPORT_DATA_FAILURE,
  CHANGE_VALUE,
  SORT_DATA,
  GET_SEARCHES_WITHOUT_CLICK_REQUEST,
  GET_SEARCHES_WITHOUT_CLICK_SUCCESS,
  GET_SEARCHES_WITHOUT_CLICK_FAILURE,
  GET_TOTAL_ACTIVITY,
  GET_TOTAL_ACTIVITY_SUCCESS,
  GET_TOTAL_ACTIVITY_FAILURE,
  GET_TOTAL_REVENUE,
  GET_TOTAL_REVENUE_SUCCESS,
  GET_TOTAL_REVENUE_FAILURE,
  GET_APP_IMPACT_CONVERSION_RATE,
  GET_APP_IMPACT_CONVERSION_RATE_SUCCESS,
  GET_APP_IMPACT_CONVERSION_RATE_FAILURE,
  GET_ORDER_COUNT,
  GET_ORDER_COUNT_SUCCESS,
  GET_ORDER_COUNT_FAILURE,
  GET_AVERAGE_ORDER_VALUE,
  GET_AVERAGE_ORDER_VALUE_SUCCESS,
  GET_AVERAGE_ORDER_VALUE_FAILURE,
  GET_REVENUE_PER_VISITOR,
  GET_REVENUE_PER_VISITOR_SUCCESS,
  GET_REVENUE_PER_VISITOR_FAILURE,
  GET_COLLECTION_CONVERSION_RATE_REQUEST,
  GET_COLLECTION_CONVERSION_RATE_SUCCESS,
  GET_COLLECTION_CONVERSION_RATE_FAILURE,
  GET_COLLECTION_TOP_REQUEST,
  GET_COLLECTION_TOP_SUCCESS,
  GET_COLLECTION_TOP_FAILURE,
  GET_COLLECTION_TOTAL_FILTER_CLICK_REQUEST,
  GET_COLLECTION_TOTAL_FILTER_CLICK_SUCCESS,
  GET_COLLECTION_TOTAL_FILTER_CLICK_FAILURE,
  GET_COLLECTION_TOTAL_REVENUE_GENERATED_REQUEST,
  GET_COLLECTION_TOTAL_REVENUE_GENERATED_SUCCESS,
  GET_COLLECTION_TOTAL_REVENUE_GENERATED_FAILURE,
  GET_COLLECTION_TOTAL_FILTER_OPTION_VALUE_COMBINATION_REQUEST,
  GET_COLLECTION_TOTAL_FILTER_OPTION_VALUE_COMBINATION_SUCCESS,
  GET_COLLECTION_TOTAL_FILTER_OPTION_VALUE_COMBINATION_FAILURE,
  GET_COLLECTION_TOTAL_FILTER_OPTION_VALUE_REQUEST,
  GET_COLLECTION_TOTAL_FILTER_OPTION_VALUE_SUCCESS,
  GET_COLLECTION_TOTAL_FILTER_OPTION_VALUE_FAILURE,
  GET_COLLECTIONS_REQUEST,
  GET_COLLECTIONS_SUCCESS,
  GET_COLLECTIONS_FAILURE,
  GET_RECOMMENDATION_TOTAL_REVENUE_REQUEST,
  GET_RECOMMENDATION_TOTAL_REVENUE_SUCCESS,
  GET_RECOMMENDATION_TOTAL_REVENUE_FAILURE,
  GET_RECOMMENDATION_CONVERSION_RATE_REQUEST,
  GET_RECOMMENDATION_CONVERSION_RATE_SUCCESS,
  GET_RECOMMENDATION_CONVERSION_RATE_FAILURE,
  GET_RECOMMENDATION_CLICK_RATE_REQUEST,
  GET_RECOMMENDATION_CLICK_RATE_SUCCESS,
  GET_RECOMMENDATION_CLICK_RATE_FAILURE,
  GET_RECOMMENDATION_TOP_PAGE_PERFORMANCE_REQUEST,
  GET_RECOMMENDATION_TOP_PAGE_PERFORMANCE_SUCCESS,
  GET_RECOMMENDATION_TOP_PAGE_PERFORMANCE_FAILURE,
  GET_RECOMMENDATION_TOP_WIDGET_PERFORMANCE_REQUEST,
  GET_RECOMMENDATION_TOP_WIDGET_PERFORMANCE_SUCCESS,
  GET_RECOMMENDATION_TOP_WIDGET_PERFORMANCE_FAILURE,
  GET_RECOMMENDATION_TOP_PRODUCT_PERFORMANCE_REQUEST,
  GET_RECOMMENDATION_TOP_PRODUCT_PERFORMANCE_SUCCESS,
  GET_RECOMMENDATION_TOP_PRODUCT_PERFORMANCE_FAILURE,
  GET_ANALYTICS_SETTINGS_REQUEST,
  GET_ANALYTICS_SETTINGS_SUCCESS,
  GET_ANALYTICS_SETTINGS_FAILURE,
  UPDATE_ANALYTICS_SETTINGS_REQUEST,
  UPDATE_ANALYTICS_SETTINGS_SUCCESS,
  UPDATE_ANALYTICS_SETTINGS_FAILURE,
  GET_TOP_SEARCH_TERMS_WITH_CLICK,
  GET_TOP_SEARCH_TERMS_WITH_CLICK_SUCCESS,
  GET_TOP_SEARCH_TERMS_WITH_CLICK_FAILURE,
  GET_PRE_ORDER_TOP_PRODUCT_REQUEST,
  GET_PRE_ORDER_TOP_PRODUCT_SUCCESS,
  GET_PRE_ORDER_TOP_PRODUCT_FAILURE,
  GET_TOTAL_AI_REVENUE_REQUEST,
  GET_TOTAL_AI_REVENUE_SUCCESS,
  GET_TOTAL_AI_REVENUE_FAILURE,
  GET_POST_PURCHASE_TOP_WIDGET_REQUEST,
  GET_POST_PURCHASE_TOP_WIDGET_SUCCESS,
  GET_POST_PURCHASE_TOP_WIDGET_FAILURE,
  GET_POST_PURCHASE_TOP_PRODUCT_REQUEST,
  GET_POST_PURCHASE_TOP_PRODUCT_SUCCESS,
  GET_POST_PURCHASE_TOP_PRODUCT_FAILURE,
} from 'stores/flow-type/analytics-v2.type';

const initialState: AnalyticsState = {
  loading: false,
  exporting: false,
  success: false,
  error: undefined,

  // Filter
  // Overview
  searchAnalyticsFromDate: undefined,
  searchAnalyticsToDate: undefined,
  searchAnalyticsCompare: false,

  // Top search terms without click
  topSearchTermsWithoutClickLoading: false,
  topSearchTermsWithoutClickSuccess: false,
  topSearchTermsWithoutClick: [],
  topSearchTermsWithoutClickExecutionId: '',

  // Searches
  // Top search term
  topSearchTermsLoading: false,
  topSearchTermsSuccess: false,
  topSearchTerms: [],
  topSearchTermsQueryExecutionId: '',

  topSearchTermsWithClickLoading: false,
  topSearchTermsWithClickSuccess: false,
  topSearchTermsWithClick: [],
  topSearchTermsWithClickExecutionId: '',

  // Top search term detail
  topSearchTermDetailLoading: false,
  topSearchTermDetailSuccess: false,
  topSearchTermDetail: [],
  topSearchTermDetailQueryExecutionId: '',

  // Top products on search
  topProductsOnSearchLoading: false,
  topProductsOnSearchSuccess: false,
  topProductsOnSearch: [],
  topProductsOnSearchExecutionId: '',

  // Searches without result rate
  searchesWithoutResultRate: [],
  searchesWithoutResultRateCompared: [],
  searchesWithoutResultRateLoading: false,
  searchesWithoutResultRateSuccess: false,
  searchesWithoutResultRateQueryExecutionId: '',
  searchesWithoutResultRateComparedQueryExecutionId: '',
  searchesWithoutResultRatePercent: '',
  searchesWithoutResultRatePercentChange: 0,

  // Total search revenue
  searchRevenue: [],
  searchRevenueCompared: [],
  searchRevenueLoading: false,
  searchRevenueSuccess: false,
  searchRevenueTotal: 0,
  searchRevenuePercentChange: 0,
  searchRevenueExecutionId: '',
  searchRevenueComparedExecutionId: '',

  // Search terms without result
  searchTermsWithoutResult: [],
  searchTermsWithoutResultLoading: false,
  searchTermsWithoutResultSuccess: false,
  searchTermsWithoutResultQueryExecutionId: '',
  searchTermsWithoutResultTotal: 0,

  // Searches click rate
  searchesClickRate: [],
  searchesClickRateCompared: [],
  searchesClickRateLoading: false,
  searchesClickRateSuccess: false,
  searchesClickRatePercent: '',
  searchesClickRatePercentChange: 0,
  searchesClickRateExecutionId: '',
  searchesClickRateComparedExecutionId: '',

  // Searches without click rate
  totalSearchesWithoutClick: [],
  totalSearchesWithoutClickCompared: [],
  totalSearchesWithoutClickLoading: false,
  totalSearchesWithoutClickSuccess: false,
  totalSearchesWithoutClickPercent: '',
  totalSearchesWithoutClickPercentChange: 0,
  totalSearchesWithoutClickExecutionId: '',
  totalSearchesWithoutClickComparedExecutionId: '',

  // Search terms without click
  searchTermsWithoutClick: [],
  searchTermsWithoutClickLoading: false,
  searchTermsWithoutClickSuccess: false,
  searchTermsWithoutClickTotal: 0,

  // Conversion rate
  conversionRate: [],
  conversionRateCompared: [],
  conversionRatePercentChange: 0,
  conversionRatePercent: '',
  conversionRateLoading: false,
  conversionRateSuccess: false,
  conversionRateQueryExecutionId: '',
  conversionRateComparedExecutionId: '',

  // COLLECTION - ANALYTICS
  // Collection: total revenue generated
  collectionTotalRevenueGenerated: [],
  collectionTotalRevenueGeneratedCompared: [],
  collectionTotalRevenueGeneratedPercentChange: 0,
  collectionTotalRevenueGeneratedTotal: '',
  collectionTotalRevenueGeneratedLoading: false,
  collectionTotalRevenueGeneratedSuccess: false,
  collectionTotalRevenueGeneratedQueryExecutionId: '',
  collectionTotalRevenueGeneratedComparedQueryExecutionId: '',

  // Collection: total filter click
  collectionTotalFilterClick: [],
  collectionTotalFilterClickCompared: [],
  collectionTotalFilterClickPercentChange: 0,
  collectionTotalFilterClickTotal: '',
  collectionTotalFilterClickLoading: false,
  collectionTotalFilterClickSuccess: false,
  collectionTotalFilterClickQueryExecutionId: '',
  collectionTotalFilterClickComparedQueryExecutionId: '',

  // Collection: conversion rate
  collectionConversionRate: [],
  collectionConversionRateCompared: [],
  collectionConversionRatePercentChange: 0,
  collectionConversionRatePercent: '',
  collectionConversionRateLoading: false,
  collectionConversionRateSuccess: false,
  collectionConversionRateQueryExecutionId: '',
  collectionConversionRateComparedQueryExecutionId: '',

  // Collection: top
  collectionTopLoading: false,
  collectionTopSuccess: false,
  collectionTop: [],
  collectionTopQueryExecutionId: '',
  collectionTopTotal: 0,

  // Collection: top filter option value
  collectionTopFilterOptionValueLoading: false,
  collectionTopFilterOptionValueSuccess: false,
  collectionTopFilterOptionValue: [],
  collectionTopFilterOptionValueQueryExecutionId: '',
  collectionTopFilterOptionValueTotal: 0,

  // Collection: top filter option value combination
  collectionTopFilterOptionValueCombinationLoading: false,
  collectionTopFilterOptionValueCombinationSuccess: false,
  collectionTopFilterOptionValueCombination: [],
  collectionTopFilterOptionValueCombinationQueryExecutionId: '',
  collectionTopFilterOptionValueCombinationTotal: 0,

  // Collection: Top collection performance
  collectionTopCollectionPerformanceLoading: false,
  collectionTopCollectionPerformanceSuccess: false,
  collectionTopCollectionPerformance: [],
  collectionTopCollectionPerformanceQueryExecutionId: '',

  // Collection: List collections
  collectionsLoading: false,
  collectionsSuccess: false,
  collections: [],
  collectionsQueryExecutionId: '',

  //=======================

  // Searches rate
  totalSearchesLoading: false,
  totalSearchesSuccess: false,
  totalSearches: [],
  totalSearchesCompared: [],
  totalSearchesNumber: '0',
  totalSearchesPercentChange: 0,
  totalSearchesQueryExecutionId: '',
  totalSearchesComparedExecutionId: '',

  // Search term searches
  searchTermsSearchesLoading: false,
  searchTermsSearchesSuccess: false,
  searchTermsSearches: [],
  searchTermsSearchesQueryExecutionId: '',
  searchTermsSearchesTotal: 0,

  // App impact
  appImpactFromDate: undefined,
  appImpactToDate: undefined,
  appImpactCompare: false,

  // Total revenue
  totalRevenueLoading: false,
  totalRevenueSuccess: false,
  totalRevenueData: [],
  totalRevenueCompared: [],
  totalRevenueTotal: {},
  totalRevenuePercentChange: {},
  totalRevenueQueryExecutionId: '',
  totalRevenueComparedQueryExecutionId: '',

  // Order count
  orderCountLoading: false,
  orderCountSuccess: false,
  orderCountData: [],
  orderCountCompared: [],
  orderCountTotal: {},
  orderCountPercentChange: {},
  orderCountQueryExecutionId: '',
  orderCountComparedQueryExecutionId: '',

  // Average order value
  averageOrderValueLoading: false,
  averageOrderValueSuccess: false,
  averageOrderValueData: [],
  averageOrderValueCompared: [],
  averageOrderValueTotal: {},
  averageOrderValuePercentChange: {},
  averageOrderValueQueryExecutionId: '',
  averageOrderValueComparedQueryExecutionId: '',

  // Revenue per visitor
  revenuePerVisitorLoading: false,
  revenuePerVisitorSuccess: false,
  revenuePerVisitorData: [],
  revenuePerVisitorCompared: [],
  revenuePerVisitorTotal: {},
  revenuePerVisitorPercentChange: {},
  revenuePerVisitorQueryExecutionId: '',
  revenuePerVisitorComparedQueryExecutionId: '',

  // Total AI revenue
  totalAIRevenueLoading: false,
  totalAIRevenueSuccess: false,
  totalAIRevenueData: [],
  totalAIRevenueCompared: [],
  totalAIRevenueTotal: {},
  totalAIRevenuePercentChange: {},
  totalAIRevenueQueryExecutionId: '',
  totalAIRevenueComparedQueryExecutionId: '',
};

const AnalyticReducers = (state: AnalyticsState = initialState, action: AnalyticsAction) => {
  switch (action.type) {
    case CHANGE_VALUE: {
      const { name, value } = action.payload;
      return {
        ...state,
        [name]: value
      };
    }

    case SORT_DATA: {
      const { name, field, direction, fieldInsensitive } = action.payload;
      let orderedData = state[name];

      if (name === 'collectionTopFilterOptionValue' && field === 'filterOptionValue') {
        const orderedData = _.orderBy(
          state[name],
          ['filterOptionLabel', 'filterOptionValue'],
          [direction, direction]
        );

        return {
          ...state,
          [name]: orderedData
        };
      }

      if (name === 'collectionTopFilterOptionValueCombination' && field === 'filterCombinations') {
        const orderedData = _(state[name])
          .map(row => {
            let { filterCombinations } = row;
            filterCombinations = _.orderBy(
              filterCombinations,
              ['filterOptionLabel', 'filterOptionValue'],
              ['asc', 'asc']
            );
            return {
              ...row,
              filterCombinations,
              filterOptionLabel: _.map(filterCombinations, 'filterOptionLabel').join('\n'),
              filterOptionValue: _.map(filterCombinations, 'filterOptionValue').join('\n')
            };
          })
          .orderBy(['filterOptionLabel', 'filterOptionValue'], [direction, direction])
          .value();

        return {
          ...state,
          [name]: orderedData
        };
      }

      if (field === 'filterCombinations') {
        const tmpData = state[name].map(row => {
          const { filterCombinations } = row;
          return {
            ...row,
            filterCombinations: _.orderBy(filterCombinations, 'filterOptionValue', direction)
          };
        });

        orderedData = tmpData.sort((a, b) => {
          if (direction === 'desc') {
            return b.filterCombinations[0].filterOptionValue.localeCompare(
              a.filterCombinations[0].filterOptionValue
            );
          }
          return a.filterCombinations[0].filterOptionValue.localeCompare(
            b.filterCombinations[0].filterOptionValue
          );
        });

        return {
          ...state,
          [name]: orderedData
        };
      }

      if (fieldInsensitive) {
        orderedData = _.orderBy(
          state[name],
          [item => String(item[fieldInsensitive]).toLowerCase()],
          direction
        );
      } else {
        orderedData = _.orderBy(state[name], field, direction);
      }

      return {
        ...state,
        [name]: orderedData
      };
    }

    // Top filter option values
    case GET_TOP_SEARCH_TERMS_REQUEST: {
      return { ...state, topSearchTermsSuccess: false, topSearchTermsLoading: true };
    }
    case GET_TOP_SEARCH_TERMS_SUCCESS: {
      let { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          topSearchTermsLoading: false,
          topSearchTermsSuccess: false
        };
      }
      const { data: topSearchTerms, queryExecutionId } = data;

      return {
        ...state,
        topSearchTermsLoading: false,
        topSearchTermsSuccess: true,
        topSearchTerms,
        topSearchTermsQueryExecutionId: queryExecutionId
      };
    }
    case GET_TOP_SEARCH_TERMS_FAILURE: {
      return {
        ...state,
        topSearchTermsLoading: false,
        topSearchTermsSuccess: false,
        error: action.payload
      };
    }

    // Top filter option values
    case GET_TOP_SEARCH_TERM_DETAIL_REQUEST: {
      return { ...state, topSearchTermDetailSuccess: false, topSearchTermDetailLoading: true };
    }
    case GET_TOP_SEARCH_TERM_DETAIL_SUCCESS: {
      let { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          topSearchTermDetailLoading: false,
          topSearchTermDetailSuccess: false
        };
      }
      const { data: topSearchTermDetail, queryExecutionId } = data;

      return {
        ...state,
        topSearchTermDetailLoading: false,
        topSearchTermDetailSuccess: true,
        topSearchTermDetail: _.orderBy(topSearchTermDetail, 'totalSales', 'desc'), // Default sort desc by totalSales
        topSearchTermDetailQueryExecutionId: queryExecutionId
      };
    }
    case GET_TOP_SEARCH_TERM_DETAIL_FAILURE: {
      return {
        ...state,
        topSearchTermDetailLoading: false,
        topSearchTermDetailSuccess: false,
        error: action.payload
      };
    }
    case GET_TOTAL_SEARCH_REVENUE_REQUEST: {
      return { ...state, searchRevenueSuccess: false, searchRevenueLoading: true };
    }
    case GET_TOTAL_SEARCH_REVENUE_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          searchRevenueLoading: false,
          searchRevenueSuccess: false
        };
      }
      const {
        data: searchRevenue,
        comparedData: searchRevenueCompared,
        total,
        percentChange,
        queryExecutionId,
        comparedExecutionId
      } = data;

      return {
        ...state,
        searchRevenueLoading: false,
        searchRevenueSuccess: true,
        searchRevenue,
        searchRevenueCompared,
        searchRevenueTotal: total,
        searchRevenuePercentChange: percentChange,
        searchRevenueExecutionId: queryExecutionId,
        searchRevenueComparedExecutionId: comparedExecutionId
      };
    }
    case GET_TOTAL_SEARCH_REVENUE_FAILURE: {
      return {
        ...state,
        searchRevenueLoading: false,
        searchRevenueSuccess: false,
        error: action.payload
      };
    }

    case GET_TOP_SEARCH_PRODUCT_PERFORMANCE_REQUEST: {
      return {
        ...state,
        topProductsOnSearchSuccess: false,
        topProductsOnSearchLoading: true
      };
    }
    case GET_TOP_SEARCH_PRODUCT_PERFORMANCE_SUCCESS: {
      let { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          topProductsOnSearchLoading: false,
          topProductsOnSearchSuccess: false
        };
      }
      const { data: topProductsOnSearch, queryExecutionId } = data;

      return {
        ...state,
        topProductsOnSearchLoading: false,
        topProductsOnSearchSuccess: true,
        topProductsOnSearch,
        topProductsOnSearchExecutionId: queryExecutionId
      };
    }
    case GET_TOP_SEARCH_PRODUCT_PERFORMANCE_FAILURE: {
      return {
        ...state,
        topProductsOnSearchLoading: false,
        topProductsOnSearchSuccess: false,
        error: action.payload
      };
    }

    case GET_TOP_SEARCH_TERMS_WITH_CLICK: {
      return {
        ...state,
        topSearchTermsWithClickLoading: true,
        topSearchTermsWithClickSuccess: false
      };
    }

    case GET_TOP_SEARCH_TERMS_WITH_CLICK_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          topSearchTermsWithClickLoading: false,
          topSearchTermsWithClickSuccess: false
        };
      }
      const { data: topSearchTermsWithClick, queryExecutionId } = data;
      return {
        ...state,
        topSearchTermsWithClickLoading: false,
        topSearchTermsWithClickSuccess: true,
        topSearchTermsWithClick,
        topSearchTermsWithClickExecutionId: queryExecutionId
      };
    }
    case GET_TOP_SEARCH_TERMS_WITH_CLICK_FAILURE: {
      return {
        ...state,
        topSearchTermsWithClickLoading: false,
        topSearchTermsWithClickSuccess: false,
        error: action.payload
      };
    }

    // Search terms without result
    case GET_SEARCH_TERMS_WITHOUT_RESULT: {
      return {
        ...state,
        searchTermsWithoutResultSuccess: false,
        searchTermsWithoutResultLoading: true
      };
    }
    case GET_SEARCH_TERMS_WITHOUT_RESULT_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          searchTermsWithoutResultLoading: false,
          searchTermsWithoutResultSuccess: false
        };
      }
      const { data: searchTermsWithoutResultData, queryExecutionId } = data;

      return {
        ...state,
        searchTermsWithoutResultLoading: false,
        searchTermsWithoutResultSuccess: true,
        searchTermsWithoutResult: searchTermsWithoutResultData.map(item => ({
          ...item,
          total: +item.total,
          percentTotalSearch: parseFloat(item.percentTotalSearch)
        })),
        searchTermsWithoutResultQueryExecutionId: queryExecutionId,
        searchTermsWithoutResultTotal: searchTermsWithoutResultData.length
      };
    }
    case GET_SEARCH_TERMS_WITHOUT_RESULT_FAILURE: {
      return {
        ...state,
        searchTermsWithoutResultSuccess: false,
        searchTermsWithoutResultLoading: false,
        error: action.payload
      };
    }
    case GET_SEARCHES_WITHOUT_CLICK_REQUEST: {
      return {
        ...state,
        topSearchTermsWithoutClickLoading: true,
        topSearchTermsWithoutClickSuccess: false
      };
    }

    case GET_SEARCHES_WITHOUT_CLICK_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          topSearchTermsWithoutClickLoading: false,
          topSearchTermsWithoutClickSuccess: false
        };
      }
      const { data: topSearchTermsWithoutClick, queryExecutionId } = data;

      return {
        ...state,
        topSearchTermsWithoutClickLoading: false,
        topSearchTermsWithoutClickSuccess: true,
        topSearchTermsWithoutClick,
        topSearchTermsWithoutClickExecutionId: queryExecutionId
      };
    }

    case GET_SEARCHES_WITHOUT_CLICK_FAILURE: {
      return {
        ...state,
        topSearchTermsWithoutClickLoading: false,
        topSearchTermsWithoutClickSuccess: false,
        error: action.payload
      };
    }

    // Searches without result rate
    case GET_SEARCHES_WITHOUT_RESULT_RATE:
      return {
        ...state,
        searchesWithoutResultRateSuccess: false,
        searchesWithoutResultRateLoading: true
      };
    case GET_SEARCHES_WITHOUT_RESULT_RATE_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          searchesWithoutResultRateLoading: false,
          searchesWithoutResultRateSuccess: false
        };
      }
      const {
        data: searchesWithoutResultRateData,
        comparedData: searchesWithoutResultRateComparedData,
        queryExecutionId,
        comparedExecutionId,
        total,
        percentChange
      } = data;

      return {
        ...state,
        searchesWithoutResultRateLoading: false,
        searchesWithoutResultRateSuccess: true,
        searchesWithoutResultRate: searchesWithoutResultRateData,
        searchesWithoutResultRateCompared: searchesWithoutResultRateComparedData,
        searchesWithoutResultRateQueryExecutionId: queryExecutionId,
        searchesWithoutResultRateComparedQueryExecutionId: comparedExecutionId,
        searchesWithoutResultRatePercent: `${total}%`,
        searchesWithoutResultRatePercentChange: percentChange
      };
    }
    case GET_SEARCHES_WITHOUT_RESULT_RATE_FAILURE: {
      return {
        ...state,
        searchesWithoutResultRateLoading: false,
        searchesWithoutResultRateSuccess: false,
        error: action.payload
      };
    }

    // Searches click rate
    case GET_SEARCHES_CLICK_RATE:
      return {
        ...state,
        searchesClickRateSuccess: false,
        searchesClickRateLoading: true
      };
    case GET_SEARCHES_CLICK_RATE_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          searchesClickRateLoading: false,
          searchesClickRateSuccess: false
        };
      }
      const {
        data: searchesClickRateData,
        comparedData: searchesClickRateComparedData,
        total,
        percentChange,
        queryExecutionId,
        comparedExecutionId
      } = data;

      return {
        ...state,
        searchesClickRateLoading: false,
        searchesClickRateSuccess: true,
        searchesClickRate: searchesClickRateData,
        searchesClickRateCompared: searchesClickRateComparedData,
        searchesClickRatePercent: `${total}%`,
        searchesClickRatePercentChange: percentChange,
        searchesClickRateExecutionId: queryExecutionId,
        searchesClickRateComparedExecutionId: comparedExecutionId
      };
    }
    case GET_SEARCHES_CLICK_RATE_FAILURE: {
      return {
        ...state,
        searchesClickRateLoading: false,
        searchesClickRateSuccess: false,
        error: action.payload
      };
    }

    // Searches without click rate
    case GET_SEARCHES_WITHOUT_CLICK_RATE:
      return {
        ...state,
        totalSearchesWithoutClickSuccess: false,
        totalSearchesWithoutClickLoading: true
      };
    case GET_SEARCHES_WITHOUT_CLICK_RATE_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          totalSearchesWithoutClickLoading: false,
          totalSearchesWithoutClickSuccess: false
        };
      }
      const {
        data: searchesWithoutClickRateData,
        comparedData: searchesWithoutClickRateComparedData,
        total,
        percentChange,
        queryExecutionId,
        comparedExecutionId
      } = data;

      return {
        ...state,
        totalSearchesWithoutClickLoading: false,
        totalSearchesWithoutClickSuccess: true,
        totalSearchesWithoutClick: searchesWithoutClickRateData,
        totalSearchesWithoutClickCompared: searchesWithoutClickRateComparedData,
        totalSearchesWithoutClickPercent: `${total}%`,
        totalSearchesWithoutClickPercentChange: percentChange,
        totalSearchesWithoutClickExecutionId: queryExecutionId,
        totalSearchesWithoutClickComparedExecutionId: comparedExecutionId
      };
    }
    case GET_SEARCHES_WITHOUT_CLICK_RATE_FAILURE: {
      return {
        ...state,
        totalSearchesWithoutClickLoading: false,
        totalSearchesWithoutClickSuccess: false,
        error: action.payload
      };
    }

    // Conversion rate
    case GET_CONVERSION_RATE:
      return {
        ...state,
        conversionRateSuccess: false,
        conversionRateLoading: true
      };
    case GET_CONVERSION_RATE_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          conversionRateLoading: false,
          conversionRateSuccess: false
        };
      }
      const {
        data: conversionRateData,
        comparedData: conversionRateComparedData,
        total,
        percentChange,
        queryExecutionId,
        comparedExecutionId
      } = data;

      return {
        ...state,
        conversionRateLoading: false,
        conversionRateSuccess: true,
        conversionRate: conversionRateData,
        conversionRateCompared: conversionRateComparedData,
        conversionRatePercent: `${total}%`,
        conversionRatePercentChange: percentChange,
        conversionRateQueryExecutionId: queryExecutionId,
        conversionRateComparedExecutionId: comparedExecutionId
      };
    }
    case GET_CONVERSION_RATE_FAILURE: {
      return {
        ...state,
        conversionRateLoading: false,
        conversionRateSuccess: false,
        error: action.payload
      };
    }

    // Collection: total revenue generated
    case GET_COLLECTION_TOTAL_REVENUE_GENERATED_REQUEST:
      return {
        ...state,
        collectionTotalRevenueGeneratedSuccess: false,
        collectionTotalRevenueGeneratedLoading: true
      };
    case GET_COLLECTION_TOTAL_REVENUE_GENERATED_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          collectionTotalRevenueGeneratedLoading: false,
          collectionTotalRevenueGeneratedSuccess: false
        };
      }
      const {
        data: collectionTotalRevenueGeneratedData,
        comparedData: collectionTotalRevenueGeneratedComparedData,
        total = 0,
        percentChange,
        queryExecutionId,
        comparedExecutionId
      } = data;

      return {
        ...state,
        collectionTotalRevenueGeneratedLoading: false,
        collectionTotalRevenueGeneratedSuccess: true,
        collectionTotalRevenueGenerated: collectionTotalRevenueGeneratedData,
        collectionTotalRevenueGeneratedCompared: collectionTotalRevenueGeneratedComparedData,
        collectionTotalRevenueGeneratedTotal: total,
        collectionTotalRevenueGeneratedPercentChange: percentChange,
        collectionTotalRevenueGeneratedQueryExecutionId: queryExecutionId,
        collectionTotalRevenueGeneratedComparedQueryExecutionId: comparedExecutionId
      };
    }
    case GET_COLLECTION_TOTAL_REVENUE_GENERATED_FAILURE: {
      return {
        ...state,
        collectionTotalRevenueGeneratedLoading: false,
        collectionTotalRevenueGeneratedSuccess: false,
        error: action.payload
      };
    }

    // Collection: total filter click
    case GET_COLLECTION_TOTAL_FILTER_CLICK_REQUEST:
      return {
        ...state,
        collectionTotalFilterClickSuccess: false,
        collectionTotalFilterClickLoading: true
      };
    case GET_COLLECTION_TOTAL_FILTER_CLICK_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          collectionTotalFilterClickLoading: false,
          collectionTotalFilterClickSuccess: false
        };
      }
      const {
        data: collectionTotalFilterClickData,
        comparedData: collectionTotalFilterClickComparedData,
        total = 0,
        percentChange,
        queryExecutionId,
        comparedExecutionId
      } = data;

      return {
        ...state,
        collectionTotalFilterClickLoading: false,
        collectionTotalFilterClickSuccess: true,
        collectionTotalFilterClick: collectionTotalFilterClickData,
        collectionTotalFilterClickCompared: collectionTotalFilterClickComparedData,
        collectionTotalFilterClickTotal: formatNumberInThousand(total),
        collectionTotalFilterClickPercentChange: percentChange,
        collectionTotalFilterClickQueryExecutionId: queryExecutionId,
        collectionTotalFilterClickComparedQueryExecutionId: comparedExecutionId
      };
    }
    case GET_COLLECTION_TOTAL_FILTER_CLICK_FAILURE: {
      return {
        ...state,
        collectionTotalFilterClickLoading: false,
        collectionTotalFilterClickSuccess: false,
        error: action.payload
      };
    }

    // Collection: conversion rate
    case GET_COLLECTION_CONVERSION_RATE_REQUEST:
      return {
        ...state,
        collectionConversionRateSuccess: false,
        collectionConversionRateLoading: true
      };
    case GET_COLLECTION_CONVERSION_RATE_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          collectionConversionRateLoading: false,
          collectionConversionRateSuccess: false
        };
      }
      const {
        data: collectionConversionRateData,
        comparedData: collectionConversionRateComparedData,
        total = 0,
        percentChange,
        queryExecutionId,
        comparedExecutionId
      } = data;

      return {
        ...state,
        collectionConversionRateLoading: false,
        collectionConversionRateSuccess: true,
        collectionConversionRate: collectionConversionRateData,
        collectionConversionRateCompared: collectionConversionRateComparedData,
        collectionConversionRatePercent: `${total}%`,
        collectionConversionRatePercentChange: percentChange,
        collectionConversionRateQueryExecutionId: queryExecutionId,
        collectionConversionRateComparedQueryExecutionId: comparedExecutionId
      };
    }
    case GET_COLLECTION_CONVERSION_RATE_FAILURE: {
      return {
        ...state,
        collectionConversionRateLoading: false,
        collectionConversionRateSuccess: false,
        error: action.payload
      };
    }

    // Collection: top
    case GET_COLLECTION_TOP_REQUEST: {
      return { ...state, collectionTopSuccess: false, collectionTopLoading: true };
    }
    case GET_COLLECTION_TOP_SUCCESS: {
      let { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          collectionTopLoading: false,
          collectionTopSuccess: false
        };
      }
      const { data: collectionTop, queryExecutionId } = data;

      return {
        ...state,
        collectionTopLoading: false,
        collectionTopSuccess: true,
        collectionTop,
        collectionTopQueryExecutionId: queryExecutionId
      };
    }
    case GET_COLLECTION_TOP_FAILURE: {
      return {
        ...state,
        collectionTopLoading: false,
        collectionTopSuccess: false,
        error: action.payload
      };
    }

    // Collection: top filter option value
    case GET_COLLECTION_TOTAL_FILTER_OPTION_VALUE_REQUEST: {
      return {
        ...state,
        collectionTopFilterOptionValueSuccess: false,
        collectionTopFilterOptionValueLoading: true
      };
    }
    case GET_COLLECTION_TOTAL_FILTER_OPTION_VALUE_SUCCESS: {
      let { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          collectionTopFilterOptionValueLoading: false,
          collectionTopFilterOptionValueSuccess: false
        };
      }
      const { data: collectionTopFilterOptionValue, queryExecutionId } = data;

      return {
        ...state,
        collectionTopFilterOptionValueLoading: false,
        collectionTopFilterOptionValueSuccess: true,
        collectionTopFilterOptionValue,
        collectionTopFilterOptionValueQueryExecutionId: queryExecutionId
      };
    }
    case GET_COLLECTION_TOTAL_FILTER_OPTION_VALUE_FAILURE: {
      return {
        ...state,
        collectionTopFilterOptionValueLoading: false,
        collectionTopFilterOptionValueSuccess: false,
        error: action.payload
      };
    }

    // Collection: top filter option value combination
    case GET_COLLECTION_TOTAL_FILTER_OPTION_VALUE_COMBINATION_REQUEST: {
      return {
        ...state,
        collectionTopFilterOptionValueCombinationSuccess: false,
        collectionTopFilterOptionValueCombinationLoading: true
      };
    }
    case GET_COLLECTION_TOTAL_FILTER_OPTION_VALUE_COMBINATION_SUCCESS: {
      let { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          collectionTopFilterOptionValueCombinationLoading: false,
          collectionTopFilterOptionValueCombinationSuccess: false
        };
      }
      const { data: collectionTopFilterOptionValueCombination, queryExecutionId } = data;

      return {
        ...state,
        collectionTopFilterOptionValueCombinationLoading: false,
        collectionTopFilterOptionValueCombinationSuccess: true,
        collectionTopFilterOptionValueCombination,
        collectionTopFilterOptionValueCombinationQueryExecutionId: queryExecutionId
      };
    }
    case GET_COLLECTION_TOTAL_FILTER_OPTION_VALUE_COMBINATION_FAILURE: {
      return {
        ...state,
        collectionTopFilterOptionValueCombinationLoading: false,
        collectionTopFilterOptionValueCombinationSuccess: false,
        error: action.payload
      };
    }

    // Collection: List collections
    case GET_COLLECTIONS_REQUEST: {
      return {
        ...state,
        collectionsSuccess: false,
        collectionsLoading: true
      };
    }
    case GET_COLLECTIONS_SUCCESS: {
      let { data: collections } = action.payload;
      if (_.isEmpty(collections)) {
        return {
          ...state,
          collectionsLoading: false,
          collectionsSuccess: false,
          collections
        };
      }

      return {
        ...state,
        collectionsLoading: false,
        collectionsSuccess: true,
        collections
      };
    }
    case GET_COLLECTIONS_FAILURE: {
      return {
        ...state,
        collectionsLoading: false,
        collectionsSuccess: false,
        error: action.payload
      };
    }

    // Searches rate
    case GET_SEARCHES_RATE:
      return {
        ...state,
        totalSearchesSuccess: false,
        totalSearchesLoading: true
      };
    case GET_SEARCHES_RATE_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          totalSearchesLoading: false,
          totalSearchesSuccess: false
        };
      }
      const {
        data: searchesRateData,
        comparedData: searchesRateComparedData,
        total,
        percentChange,
        queryExecutionId,
        comparedExecutionId
      } = data;

      return {
        ...state,
        totalSearchesLoading: false,
        totalSearchesSuccess: true,
        totalSearches: searchesRateData,
        totalSearchesCompared: searchesRateComparedData,
        totalSearchesNumber: formatNumberInThousand(total),
        totalSearchesPercentChange: percentChange,
        totalSearchesQueryExecutionId: queryExecutionId,
        totalSearchesComparedExecutionId: comparedExecutionId
      };
    }
    case GET_SEARCHES_RATE_FAILURE: {
      return {
        ...state,
        totalSearchesLoading: false,
        totalSearchesSuccess: false,
        error: action.payload
      };
    }

    case EXPORT_DATA_REQUEST:
      return {
        ...state,
        exporting: true
      };
    case EXPORT_DATA_SUCCESS: {
      return {
        ...state,
        exporting: false
      };
    }
    case EXPORT_DATA_FAILURE:
      return {
        ...state,
        exporting: false,
        error: action.payload
      };

    // App impact

    // Total activity
    ///
    case GET_TOTAL_ACTIVITY: {
      return {
        ...state,
        totalActivityLoading: true,
        totalActivitySuccess: false
      };
    }
    case GET_TOTAL_ACTIVITY_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          totalActivityLoading: false,
          totalActivitySuccess: false
        };
      }
      const {
        total: totalActivityTotal,
        percentChange: totalActivityPercentChange,
        queryExecutionId,
        comparedExecutionId
      } = data;

      return {
        ...state,
        totalActivityLoading: false,
        totalActivitySuccess: true,
        totalActivityTotal,
        totalActivityPercentChange: totalActivityPercentChange,
        totalActivityQueryExecutionId: queryExecutionId,
        totalActivityComparedQueryExecutionId: comparedExecutionId
      };
    }
    case GET_TOTAL_ACTIVITY_FAILURE: {
      return {
        ...state,
        totalActivityLoading: false,
        totalActivitySuccess: false,
        error: action.payload
      };
    }

    // Total revenue
    ///
    case GET_TOTAL_REVENUE: {
      return {
        ...state,
        totalRevenueLoading: true,
        totalRevenueSuccess: false
      };
    }
    case GET_TOTAL_REVENUE_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          totalRevenueLoading: false,
          totalRevenueSuccess: false
        };
      }
      const {
        total: totalRevenueTotal,
        totalCollection: totalRevenueByCollection,
        totalSearch: totalRevenueBySearch,
        totalRecommend: totalRevenueByRecommend,
        data: totalRevenueData,
        comparedData: totalRevenueDataCompared,
        percentChange: totalRevenuePercentChange,
        percentChangeCollection: totalRevenuePercentChangeByCollection,
        percentChangeSearch: totalRevenuePercentChangeBySearch,
        percentChangeRecommend: totalRevenuePercentChangeByRecommend,
        queryExecutionId,
        comparedExecutionId
      } = data;

      return {
        ...state,
        totalRevenueLoading: false,
        totalRevenueSuccess: true,
        totalRevenueData: totalRevenueData,
        totalRevenueCompared: totalRevenueDataCompared,
        totalRevenueTotal: {
          all: totalRevenueTotal,
          collection: totalRevenueByCollection,
          search: totalRevenueBySearch,
          recommend: totalRevenueByRecommend
        },
        totalRevenuePercentChange: {
          all: totalRevenuePercentChange,
          collection: totalRevenuePercentChangeByCollection,
          search: totalRevenuePercentChangeBySearch,
          recommend: totalRevenuePercentChangeByRecommend
        },
        totalRevenueQueryExecutionId: queryExecutionId,
        totalRevenueComparedQueryExecutionId: comparedExecutionId
      };
    }
    case GET_TOTAL_REVENUE_FAILURE: {
      return {
        ...state,
        totalRevenueLoading: false,
        totalRevenueSuccess: false,
        error: action.payload
      };
    }

    // App impact: Conversion rate
    case GET_APP_IMPACT_CONVERSION_RATE:
      return {
        ...state,
        totalConversionRateLoading: true,
        totalConversionRateSuccess: false
      };
    case GET_APP_IMPACT_CONVERSION_RATE_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          totalConversionRateLoading: false,
          totalConversionRateSuccess: false
        };
      }
      const {
        total: totalConversionRateTotal,
        totalCollection: totalConversionRateByCollection,
        totalSearch: totalConversionRateBySearch,
        totalRecommend: totalConversionRateByRecommend,
        data: totalConversionRateData,
        comparedData: totalConversionRateDataCompared,
        percentChange: totalConversionRatePercentChange,
        percentChangeCollection: totalConversionRatePercentChangeByCollection,
        percentChangeSearch: totalConversionRatePercentChangeBySearch,
        percentChangeRecommend: totalConversionRatePercentChangeByRecommend,
        queryExecutionId,
        comparedExecutionId
      } = data;

      return {
        ...state,
        totalConversionRateLoading: false,
        totalConversionRateSuccess: true,
        totalConversionRateData: totalConversionRateData,
        totalConversionRateCompared: totalConversionRateDataCompared,
        totalConversionRateTotal: {
          all: `${totalConversionRateTotal}%`,
          collection: `${totalConversionRateByCollection}%`,
          search: `${totalConversionRateBySearch}%`,
          recommend: `${totalConversionRateByRecommend}%`
        },
        totalConversionRatePercentChange: {
          all: totalConversionRatePercentChange,
          collection: totalConversionRatePercentChangeByCollection,
          search: totalConversionRatePercentChangeBySearch,
          recommend: totalConversionRatePercentChangeByRecommend
        },
        totalConversionRateQueryExecutionId: queryExecutionId,
        totalConversionRateComparedQueryExecutionId: comparedExecutionId
      };
    }
    case GET_APP_IMPACT_CONVERSION_RATE_FAILURE: {
      return {
        ...state,
        totalConversionRateLoading: false,
        totalConversionRateSuccess: false,
        error: action.payload
      };
    }

    // Order count
    case GET_ORDER_COUNT: {
      return {
        ...state,
        orderCountLoading: true,
        orderCountSuccess: false
      };
    }
    case GET_ORDER_COUNT_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          orderCountLoading: false,
          orderCountSuccess: false
        };
      }
      const {
        total: orderCountTotal,
        totalCollection: orderCountByCollection,
        totalSearch: orderCountBySearch,
        totalRecommend: orderCountByRecommend,
        data: orderCountData,
        comparedData: orderCountDataCompared,
        percentChange: orderCountPercentChange,
        percentChangeCollection: orderCountPercentChangeByCollection,
        percentChangeSearch: orderCountPercentChangeBySearch,
        percentChangeRecommend: orderCountPercentChangeByRecommend,
        queryExecutionId,
        comparedExecutionId
      } = data;

      return {
        ...state,
        orderCountLoading: false,
        orderCountSuccess: true,
        orderCountData: orderCountData,
        orderCountCompared: orderCountDataCompared,
        orderCountTotal: {
          all: orderCountTotal,
          collection: orderCountByCollection,
          search: orderCountBySearch,
          recommend: orderCountByRecommend
        },
        orderCountPercentChange: {
          all: orderCountPercentChange,
          collection: orderCountPercentChangeByCollection,
          search: orderCountPercentChangeBySearch,
          recommend: orderCountPercentChangeByRecommend
        },
        orderCountQueryExecutionId: queryExecutionId,
        orderCountComparedQueryExecutionId: comparedExecutionId
      };
    }
    case GET_ORDER_COUNT_FAILURE: {
      return {
        ...state,
        orderCountLoading: false,
        orderCountSuccess: false,
        error: action.payload
      };
    }

    // Average order value
    case GET_AVERAGE_ORDER_VALUE: {
      return {
        ...state,
        averageOrderValueLoading: true,
        averageOrderValueSuccess: false
      };
    }
    case GET_AVERAGE_ORDER_VALUE_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          averageOrderValueLoading: false,
          averageOrderValueSuccess: false
        };
      }
      const {
        total: averageOrderValueTotal,
        totalCollection: averageOrderValueByCollection,
        totalSearch: averageOrderValueBySearch,
        totalRecommend: averageOrderValueByRecommend,
        data: averageOrderValueData,
        comparedData: averageOrderValueDataCompared,
        percentChange: averageOrderValuePercentChange,
        percentChangeCollection: averageOrderValuePercentChangeByCollection,
        percentChangeSearch: averageOrderValuePercentChangeBySearch,
        percentChangeRecommend: averageOrderValuePercentChangeByRecommend,
        queryExecutionId,
        comparedExecutionId
      } = data;

      return {
        ...state,
        averageOrderValueLoading: false,
        averageOrderValueSuccess: true,
        averageOrderValueData: averageOrderValueData,
        averageOrderValueCompared: averageOrderValueDataCompared,
        averageOrderValueTotal: {
          all: averageOrderValueTotal,
          collection: averageOrderValueByCollection,
          search: averageOrderValueBySearch,
          recommend: averageOrderValueByRecommend
        },
        averageOrderValuePercentChange: {
          all: averageOrderValuePercentChange,
          collection: averageOrderValuePercentChangeByCollection,
          search: averageOrderValuePercentChangeBySearch,
          recommend: averageOrderValuePercentChangeByRecommend
        },
        averageOrderValueQueryExecutionId: queryExecutionId,
        averageOrderValueComparedQueryExecutionId: comparedExecutionId
      };
    }
    case GET_AVERAGE_ORDER_VALUE_FAILURE: {
      return {
        ...state,
        averageOrderValueLoading: false,
        averageOrderValueSuccess: false,
        error: action.payload
      };
    }

    // Revenue per visitor
    case GET_REVENUE_PER_VISITOR: {
      return {
        ...state,
        revenuePerVisitorLoading: true,
        revenuePerVisitorSuccess: false
      };
    }
    case GET_REVENUE_PER_VISITOR_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          revenuePerVisitorLoading: false,
          revenuePerVisitorSuccess: false
        };
      }
      const {
        total: revenuePerVisitorTotal,
        totalCollection: revenuePerVisitorByCollection,
        totalSearch: revenuePerVisitorBySearch,
        totalRecommend: revenuePerVisitorByRecommend,
        data: revenuePerVisitorData,
        comparedData: revenuePerVisitorDataCompared,
        percentChange: revenuePerVisitorPercentChange,
        percentChangeCollection: revenuePerVisitorPercentChangeByCollection,
        percentChangeSearch: revenuePerVisitorPercentChangeBySearch,
        percentChangeRecommend: revenuePerVisitorPercentChangeByRecommend,
        queryExecutionId,
        comparedExecutionId
      } = data;

      return {
        ...state,
        revenuePerVisitorLoading: false,
        revenuePerVisitorSuccess: true,
        revenuePerVisitorData: revenuePerVisitorData,
        revenuePerVisitorCompared: revenuePerVisitorDataCompared,
        revenuePerVisitorTotal: {
          all: revenuePerVisitorTotal,
          collection: revenuePerVisitorByCollection,
          search: revenuePerVisitorBySearch,
          recommend: revenuePerVisitorByRecommend
        },
        revenuePerVisitorPercentChange: {
          all: revenuePerVisitorPercentChange,
          collection: revenuePerVisitorPercentChangeByCollection,
          search: revenuePerVisitorPercentChangeBySearch,
          recommend: revenuePerVisitorPercentChangeByRecommend
        },
        revenuePerVisitorQueryExecutionId: queryExecutionId,
        revenuePerVisitorComparedQueryExecutionId: comparedExecutionId
      };
    }
    case GET_REVENUE_PER_VISITOR_FAILURE: {
      return {
        ...state,
        revenuePerVisitorLoading: false,
        revenuePerVisitorSuccess: false,
        error: action.payload
      };
    }

    // START: Recommendation

    // Recommendation: total revenue
    case GET_RECOMMENDATION_TOTAL_REVENUE_REQUEST:
      return {
        ...state,
        recommendationTotalRevenueSuccess: false,
        recommendationTotalRevenueLoading: true
      };
    case GET_RECOMMENDATION_TOTAL_REVENUE_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          recommendationTotalRevenueLoading: false,
          recommendationTotalRevenueSuccess: false
        };
      }
      const {
        data: recommendationTotalRevenueData,
        comparedData: recommendationTotalRevenueComparedData,
        total = 0,
        percentChange,
        queryExecutionId,
        comparedExecutionId
      } = data;

      return {
        ...state,
        recommendationTotalRevenueLoading: false,
        recommendationTotalRevenueSuccess: true,
        recommendationTotalRevenue: recommendationTotalRevenueData,
        recommendationTotalRevenueCompared: recommendationTotalRevenueComparedData,
        recommendationTotalRevenueTotal: total,
        recommendationTotalRevenuePercentChange: percentChange,
        recommendationTotalRevenueQueryExecutionId: queryExecutionId,
        recommendationTotalRevenueComparedQueryExecutionId: comparedExecutionId
      };
    }
    case GET_RECOMMENDATION_TOTAL_REVENUE_FAILURE: {
      return {
        ...state,
        recommendationTotalRevenueLoading: false,
        recommendationTotalRevenueSuccess: false,
        error: action.payload
      };
    }

    // Recommendation: Conversion rate
    case GET_RECOMMENDATION_CONVERSION_RATE_REQUEST:
      return {
        ...state,
        recommendationConversionRateSuccess: false,
        recommendationConversionRateLoading: true
      };
    case GET_RECOMMENDATION_CONVERSION_RATE_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          recommendationConversionRateLoading: false,
          recommendationConversionRateSuccess: false
        };
      }
      const {
        data: recommendationConversionRateData,
        comparedData: recommendationConversionRateComparedData,
        total,
        percentChange,
        queryExecutionId,
        comparedExecutionId
      } = data;

      return {
        ...state,
        recommendationConversionRateLoading: false,
        recommendationConversionRateSuccess: true,
        recommendationConversionRate: recommendationConversionRateData,
        recommendationConversionRateCompared: recommendationConversionRateComparedData,
        recommendationConversionRatePercent: `${total}%`,
        recommendationConversionRatePercentChange: percentChange,
        recommendationConversionRateQueryExecutionId: queryExecutionId,
        recommendationConversionRateComparedQueryExecutionId: comparedExecutionId
      };
    }
    case GET_RECOMMENDATION_CONVERSION_RATE_FAILURE: {
      return {
        ...state,
        recommendationConversionRateLoading: false,
        recommendationConversionRateSuccess: false,
        error: action.payload
      };
    }

    // Recommendation: Click rate
    case GET_RECOMMENDATION_CLICK_RATE_REQUEST:
      return {
        ...state,
        recommendationClickRateSuccess: false,
        recommendationClickRateLoading: true
      };
    case GET_RECOMMENDATION_CLICK_RATE_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          recommendationClickRateLoading: false,
          recommendationClickRateSuccess: false
        };
      }
      const {
        data: recommendationClickRateData,
        comparedData: recommendationClickRateComparedData,
        total,
        percentChange,
        queryExecutionId,
        comparedExecutionId
      } = data;

      return {
        ...state,
        recommendationClickRateLoading: false,
        recommendationClickRateSuccess: true,
        recommendationClickRate: recommendationClickRateData,
        recommendationClickRateCompared: recommendationClickRateComparedData,
        recommendationClickRatePercent: `${total}%`,
        recommendationClickRatePercentChange: percentChange,
        recommendationClickRateQueryExecutionId: queryExecutionId,
        recommendationClickRateComparedQueryExecutionId: comparedExecutionId
      };
    }
    case GET_RECOMMENDATION_CLICK_RATE_FAILURE: {
      return {
        ...state,
        recommendationClickRateLoading: false,
        recommendationClickRateSuccess: false,
        error: action.payload
      };
    }

    // Recommendation: top page performance
    case GET_RECOMMENDATION_TOP_PAGE_PERFORMANCE_REQUEST: {
      return {
        ...state,
        recommendationTopPagePerformanceSuccess: false,
        recommendationTopPagePerformanceLoading: true
      };
    }
    case GET_RECOMMENDATION_TOP_PAGE_PERFORMANCE_SUCCESS: {
      let { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          recommendationTopPagePerformanceLoading: false,
          recommendationTopPagePerformanceSuccess: false
        };
      }
      const { data: recommendationTopPagePerformance, queryExecutionId } = data;

      return {
        ...state,
        recommendationTopPagePerformanceLoading: false,
        recommendationTopPagePerformanceSuccess: true,
        recommendationTopPagePerformance,
        recommendationTopPagePerformanceQueryExecutionId: queryExecutionId
      };
    }
    case GET_RECOMMENDATION_TOP_PAGE_PERFORMANCE_FAILURE: {
      return {
        ...state,
        recommendationTopPagePerformanceLoading: false,
        recommendationTopPagePerformanceSuccess: false,
        error: action.payload
      };
    }

    // Recommendation: top widget performance
    case GET_RECOMMENDATION_TOP_WIDGET_PERFORMANCE_REQUEST: {
      return {
        ...state,
        recommendationTopWidgetPerformanceSuccess: false,
        recommendationTopWidgetPerformanceLoading: true
      };
    }
    case GET_RECOMMENDATION_TOP_WIDGET_PERFORMANCE_SUCCESS: {
      let { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          recommendationTopWidgetPerformanceLoading: false,
          recommendationTopWidgetPerformanceSuccess: false
        };
      }
      const { data: recommendationTopWidgetPerformance, queryExecutionId } = data;

      return {
        ...state,
        recommendationTopWidgetPerformanceLoading: false,
        recommendationTopWidgetPerformanceSuccess: true,
        recommendationTopWidgetPerformance,
        recommendationTopWidgetPerformanceQueryExecutionId: queryExecutionId
      };
    }
    case GET_RECOMMENDATION_TOP_WIDGET_PERFORMANCE_FAILURE: {
      return {
        ...state,
        recommendationTopWidgetPerformanceLoading: false,
        recommendationTopWidgetPerformanceSuccess: false,
        error: action.payload
      };
    }

    // Recommendation: top product performance
    case GET_RECOMMENDATION_TOP_PRODUCT_PERFORMANCE_REQUEST: {
      return {
        ...state,
        recommendationTopProductPerformanceSuccess: false,
        recommendationTopProductPerformanceLoading: true
      };
    }
    case GET_RECOMMENDATION_TOP_PRODUCT_PERFORMANCE_SUCCESS: {
      let { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          recommendationTopProductPerformanceLoading: false,
          recommendationTopProductPerformanceSuccess: false
        };
      }
      const { data: recommendationTopProductPerformance, queryExecutionId } = data;

      return {
        ...state,
        recommendationTopProductPerformanceLoading: false,
        recommendationTopProductPerformanceSuccess: true,
        recommendationTopProductPerformance,
        recommendationTopProductPerformanceQueryExecutionId: queryExecutionId
      };
    }
    case GET_RECOMMENDATION_TOP_PRODUCT_PERFORMANCE_FAILURE: {
      return {
        ...state,
        recommendationTopProductPerformanceLoading: false,
        recommendationTopProductPerformanceSuccess: false,
        error: action.payload
      };
    }

    // END: Recommendation

    // START: Pre-Order

    // Top product pre-order
    case GET_PRE_ORDER_TOP_PRODUCT_REQUEST: {
      return { ...state, preOrderTopProductSuccess: false, preOrderTopProductLoading: true };
    }
    case GET_PRE_ORDER_TOP_PRODUCT_SUCCESS: {
      let { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          preOrderTopProductLoading: false,
          preOrderTopProductSuccess: false
        };
      }
      const { data: preOrderTopProduct, queryExecutionId } = data;

      return {
        ...state,
        preOrderTopProductLoading: false,
        preOrderTopProductSuccess: true,
        preOrderTopProduct,
        preOrderTopProductQueryExecutionId: queryExecutionId
      };
    }
    case GET_PRE_ORDER_TOP_PRODUCT_FAILURE: {
      return {
        ...state,
        preOrderTopProductLoading: false,
        preOrderTopProductSuccess: false,
        error: action.payload
      };
    }

    // END: Pre-Order

    // START: Post-Purchase

    // Top widget post-purchase
    case GET_POST_PURCHASE_TOP_WIDGET_REQUEST: {
      return { ...state, postPurchaseTopWidgetSuccess: false, postPurchaseTopWidgetLoading: true };
    }
    case GET_POST_PURCHASE_TOP_WIDGET_SUCCESS: {
      let { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          postPurchaseTopWidgetLoading: false,
          postPurchaseTopWidgetSuccess: false
        };
      }
      const { data: postPurchaseTopWidget, queryExecutionId } = data;

      return {
        ...state,
        postPurchaseTopWidgetLoading: false,
        postPurchaseTopWidgetSuccess: true,
        postPurchaseTopWidget,
        postPurchaseTopWidgetQueryExecutionId: queryExecutionId
      };
    }
    case GET_POST_PURCHASE_TOP_WIDGET_FAILURE: {
      return {
        ...state,
        postPurchaseTopWidgetLoading: false,
        postPurchaseTopWidgetSuccess: false,
        error: action.payload
      };
    }

    // Top product post-purchase
    case GET_POST_PURCHASE_TOP_PRODUCT_REQUEST: {
      return { ...state, postPurchaseTopProductSuccess: false, postPurchaseTopProductLoading: true };
    }
    case GET_POST_PURCHASE_TOP_PRODUCT_SUCCESS: {
      let { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          postPurchaseTopProductLoading: false,
          postPurchaseTopProductSuccess: false
        };
      }
      const { data: postPurchaseTopProduct, queryExecutionId } = data;

      return {
        ...state,
        postPurchaseTopProductLoading: false,
        postPurchaseTopProductSuccess: true,
        postPurchaseTopProduct,
        postPurchaseTopProductQueryExecutionId: queryExecutionId
      };
    }
    case GET_POST_PURCHASE_TOP_PRODUCT_FAILURE: {
      return {
        ...state,
        postPurchaseTopProductLoading: false,
        postPurchaseTopProductSuccess: false,
        error: action.payload
      };
    }

    // END: Post-Purchase

    // Get settings
    case GET_ANALYTICS_SETTINGS_REQUEST:
      return { ...state, loadingAnalyticsSettings: true };
    case GET_ANALYTICS_SETTINGS_SUCCESS: {
      const { data } = action.payload.data;
      return {
        ...state,
        loadingAnalyticsSettings: false,
        error: undefined,
        analyticsSettings: { ...data }
      };
    }
    case GET_ANALYTICS_SETTINGS_FAILURE:
      return {
        ...state,
        loadingAnalyticsSettings: false,
        error: action.payload
      };

    //Update settings
    case UPDATE_ANALYTICS_SETTINGS_REQUEST:
      return { ...state, savingAnalyticsSettings: true };
    case UPDATE_ANALYTICS_SETTINGS_SUCCESS: {
      const { data } = action.payload.data;
      return {
        ...state,
        savingAnalyticsSettings: false,
        error: undefined,
        analyticsSettings: { ...data }
      };
    }
    case UPDATE_ANALYTICS_SETTINGS_FAILURE:
      return {
        ...state,
        savingAnalyticsSettings: false,
        error: action.payload
      };

    // Total AI revenue
    ///
    case GET_TOTAL_AI_REVENUE_REQUEST: {
      return {
        ...state,
        totalAIRevenueLoading: true,
        totalAIRevenueSuccess: false
      };
    }
    case GET_TOTAL_AI_REVENUE_SUCCESS: {
      const { data } = action.payload;
      if (_.isEmpty(data)) {
        return {
          ...state,
          totalAIRevenueLoading: false,
          totalAIRevenueSuccess: false
        };
      }
      const {
        total: totalRevenueTotal,
        totalCollection: totalRevenueByCollection,
        totalSearch: totalRevenueBySearch,
        totalRecommend: totalRevenueByRecommend,
        data: totalRevenueData,
        comparedData: totalRevenueDataCompared,
        percentChange: totalRevenuePercentChange,
        percentChangeCollection: totalRevenuePercentChangeByCollection,
        percentChangeSearch: totalRevenuePercentChangeBySearch,
        percentChangeRecommend: totalRevenuePercentChangeByRecommend,
        queryExecutionId,
        comparedExecutionId
      } = data;

      return {
        ...state,
        totalAIRevenueLoading: false,
        totalAIRevenueSuccess: true,
        totalAIRevenueData: totalRevenueData,
        totalAIRevenueCompared: totalRevenueDataCompared,
        totalAIRevenueTotal: {
          all: totalRevenueTotal,
          collection: totalRevenueByCollection,
          search: totalRevenueBySearch,
          recommend: totalRevenueByRecommend
        },
        totalAIRevenuePercentChange: {
          all: totalRevenuePercentChange,
          collection: totalRevenuePercentChangeByCollection,
          search: totalRevenuePercentChangeBySearch,
          recommend: totalRevenuePercentChangeByRecommend
        },
        totalAIRevenueQueryExecutionId: queryExecutionId,
        totalAIRevenueComparedQueryExecutionId: comparedExecutionId
      };
    }
    case GET_TOTAL_AI_REVENUE_FAILURE: {
      return {
        ...state,
        totalAIRevenueLoading: false,
        totalAIRevenueSuccess: false,
        error: action.payload
      };
    }

    default:
      return state;
  }
};
export default AnalyticReducers;
